import { render, staticRenderFns } from "./StudentExercisesWidget.vue?vue&type=template&id=37a90098&scoped=true"
import script from "./StudentExercisesWidget.vue?vue&type=script&lang=js"
export * from "./StudentExercisesWidget.vue?vue&type=script&lang=js"
import style0 from "./StudentExercisesWidget.vue?vue&type=style&index=0&id=37a90098&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a90098",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37a90098')) {
      api.createRecord('37a90098', component.options)
    } else {
      api.reload('37a90098', component.options)
    }
    module.hot.accept("./StudentExercisesWidget.vue?vue&type=template&id=37a90098&scoped=true", function () {
      api.rerender('37a90098', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Widgets/StudentExercisesWidget.vue"
export default component.exports